import React, { useState } from "react";
import { Header, Text } from "@centrate-io/barn";
import { useParams } from "react-router-dom";

function LeinReport(props) {
    const params = useParams();
    const deal_id = params?.id;
    return (
        <div className="crumbs" style={{padding: 32}}>
            <Header type="display" size="5">
            Lein Report
            </Header>
            <Text type="helper">Upload Lein Report</Text>
        </div>
    );
  }
  
  export default LeinReport;